export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const SIGNIN_REQUEST_SENT = 'SIGNIN_REQUEST_SENT'

export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS'
export const REGISTRATION_FAILURE = 'REGISTRATION_FAILURE'
export const REGISTRATION_REQUEST_SENT = 'REGISTRATION_REQUEST_SENT'

export const PASSWORDRESET_SUCCESS = 'PASSWORDRESET_SUCCESS'
export const PASSWORDRESET_FAILURE = 'PASSWORDRESET_FAILURE'
export const PASSWORDRESET_REQUEST_SENT = 'PASSWORDRESET_REQUEST_SENT'


export const SIGNOUT_REQUEST_SENT = 'SIGNOUT_REQUEST_SENT'
